import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const notesRequiringApprovalSchema = new schema.Entity('notesReqApprovalContainer', {
    notesReqApproval: [schemas.noteReqApproval],
    notesReqApprovalMsgs: [schemas.noteReqApprovalMsgs]
});

export const notesPendingActionSchema = new schema.Entity('notesPendingActionContainer', {
    notesPendingAction: [schemas.notePendingAction],
    notesPendingActionMsgs: [schemas.notePendingActionMsgs]
});


export const pndueSchema = new schema.Entity('pndueContainer', {
    pndue: [schemas.pndue]
});

export const dcdueSchema = new schema.Entity('dcdueContainer', {
    dcdue: [schemas.dcdue]
});

export const specProgReqMsgsSchema = new schema.Entity('specProgReqMsgsContainer', {
    specProgReqMsgs: [schemas.specProgReqMsgs],
    specProgReqMsgDetails: [schemas.specProgReqMsgDetails]
});

export const federalReviewMsgsSchema = new schema.Entity('federalReviewMsgsContainer', {
    federalReviewMsgs: [schemas.federalReviewMsgs],
    federalReviewMsgAdmissions: [schemas.federalReviewMsgAdmissions],
    federalReviewMsgDetails: [schemas.federalReviewMsgDetails]
});

export const mcDiaryItemsSchema = new schema.Entity('mcDiaryItemsContainer', {
    mcDiaryItems: [schemas.mcDiaryItems]
});

